/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Checkbox } from '@atoms';
import { useTag } from '@api/hooks';
import { ArticleTagField, ContentModuleModal, TextField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS, INITIAL_VALUES } from './constants';
import Item from './Item';

const NewsCarouselModal = ({
  visible,
  hide,
  previewImg,
  onDelete,
  onSubmit,
  initialValues: data = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const [filterByTag, setFilterByTag] = React.useState(Boolean(data.tagId));
  const initialValues = React.useMemo(() => form.deserialize(data), [form, data]);

  const tagQuery = useTag(data.tagId);
  React.useEffect(() => {
    if (visible && tagQuery.status === 'success') {
      form.setFieldsValue({ [FORM_FIELD.TAG.name]: tagQuery.data });
    }
  }, [form, tagQuery.data, tagQuery.status, tagQuery.tag, visible]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleFilterByTag = ({ target }) => {
    setFilterByTag(target.checked);
  };

  React.useEffect(() => {
    if (filterByTag) {
      form.resetFields([FORM_FIELD.TAG.name]);
    }
  }, [filterByTag, form]);

  return (
    <ContentModuleModal
      visible={visible}
      title="Latest news carousel"
      subtitle="Show the 30 latest news articles"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LATEST NEWS'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        onSerializedFinish={handleSubmit}
        layout="vertical"
        name="latestNews"
        initialValues={initialValues}
      >
        <Checkbox checked={filterByTag} onChange={handleFilterByTag} style={{ marginBottom: 15 }}>
          Filter by content tag
        </Checkbox>
        <ArticleTagField
          {...FORM_FIELD.TAG}
          name={filterByTag && FORM_FIELD.TAG.name}
          rules={filterByTag && FORM_FIELD.TAG.rules}
          disabled={!filterByTag}
          style={NO_MARGIN_BOTTOM}
        />
        <TextField {...FORM_FIELD.MORE_NEWS_LINK} style={{ marginTop: 10, width: '100%' }} />
      </Form>
    </ContentModuleModal>
  );
};

NewsCarouselModal.Item = Item;

export default NewsCarouselModal;
